import pictures from '../../assests/assestimport.js';
const {ep} = pictures;

const eyewear=[
    {
        id:1,
        label:'3M™ 334AF Chemical Splash Goggle 40661-00000-10DP, Clear Anti-Fog,',
        band:"3M",
        description:`3M™ SPLASH GOGGLE
        LENS : CLEAR, Impact Resistant Polycarbonate Lens With 99.9 % UV Protection. 
        COATING : Anti-Fog
        FEATURES : Indirect-Venting System Designed To Circulate Air and Help Minimize Fogging While Keeping Liquids Out, 
        Adjustable Elastic Strap, Over-The-Glass Coverage, Economical.`,
        image:ep[0],
        alt:"3M™ 334AF Chemical Splash Goggle 40661-00000-10DP, Clear Anti-Fog,",
        hscode:'',
    },
    {
        id:2,
        label:'3M Linte Cinza Trans',
        band:"3M",
        description:`3M™ SPECTACLE - VIRTUA SERIES
        LENS : CLEAR, Impact Resistant Polycarbonate Lens With 99.9 % UV Protection. 
        FRAME : Frameless Design.
        TEMPLE : Lens Colored  Spatula TypeTemple.
        FEATURES : Integrated Nose Bridge, Highly Flexible Single Lens Design, Light Weight.`,
        image:ep[1],
        alt:"3M Linte Cinza Trans protective eyewear",
        hscode:'',
    },
    {
        id:3,
        label:'3M Linte Cinza Grey',
        band:"3M",
        description:`3M™ SPECTACLE - VIRTUA SERIES
        LENS : GREY, Impact Resistant Polycarbonate Lens With 99.9 % UV Protection. 
        FRAME : Frameless Design.
        TEMPLE : Lens Colored  Spatula TypeTemple.
        FEATURES : Integrated Nose Bridge, Highly Flexible Single Lens Design, Light Weight.`,
        image:ep[2],
        alt:"3M Linte Cinza Grey protective eyewear",
        hscode:'',
    },
    {
        id:4,
        label:'3M™ Virtua™ AP Protective Eyewear 11815-00000-20 Gray Hard Coat Lens',
        band:"3M",
        description:`3M™ SPECTACLE - VIRTUA AP SERIES
        LENS : GREY, Impact Resistant Polycarbonate Lens With 99.9 % UV Protection. 
        COATING : Anti-Scratch.
        FRAME : Frameless Design.
        TEMPLE : Lens Colored Soft Temple.
        FEATURES : Light Weight, High Wrap Lens, Integral Side Shields and Brow Guard.`,
        image:ep[3],
        alt:"3M™ Virtua™ AP Protective Eyewear 11815-00000-20 Gray Hard Coat Lens",
        hscode:'',
    },
    {
        id:5,
        label:'3M™ Virtua™ AP Safety Glasses',
        band:"3M",
        description:`3M™ SPECTACLE - VIRTUA AP SERIES
        LENS : CLEAR, Impact Resistant Polycarbonate Lens With 99.9 % UV Protection. 
        COATING : Anti-Scratch.
        FRAME : Frameless Design.
        TEMPLE : Lens Colored Soft Temple.
        FEATURES : Light Weight, High Wrap Lens, Integral Side Shields and Brow Guard.`,
        image:ep[4],
        alt:"3M™ Virtua™ AP Safety Glasses",
        hscode:'',
    },
    {
        id:6,
        label:'Safety Plus World Eyewear SP-302CL, SP-302SM',
        band:"Safetyplus world",
        description:`Safetyplus world basic Eyewear , Flexible Nylon frame & temples, High Performance polycarbonate lens, Fits all Heads• Wrap-around popular model
        Flexible nylon frame & temples
        High performance polycarbonate lens
        Thin end temples brings pressure free
        fitting & adjustable length
        Fits all the heads
        Anti-UV/ anti-scratch
        Standard: Complies to CE EN166:2002`,
        image:ep[5],
        alt:"Safety Plus World Eyewear SP-302CL, SP-302SM protective eyewear",
        hscode:'',
    },
    {
        id:7,
        label:'VENUS G-102 CHC/GHC',
        band:"VENUS",
        description:`VENUS G-102 CHC / GHC
        Approval: AS PER ANSI
        Color: Clear/Grey`,
        image:ep[6],
        alt:"VENUS G-102 CHC/GHC protective eyewear",
        hscode:'',
    },
    {
        id:8,
        label:'VENUS G-403 CHC/GHC',
        band:"VENUS",
        description:`VENUS G-403 CHC / GHC
        Approval: AS PER ANSI
        Color: Clear/Grey`,
        image:ep[7],
        alt:"VENUS G-403 CHC/GHC protective eyewear",
        hscode:'',
    },
    {
        id:9,
        label:'VENUS G-306 AF CHC/GHC',
        band:"VENUS",
        description:`VENUS G-306 AF CHC / GHC
        Approval: AS PER ANSI
        Color: Clear/Grey`,
        image:ep[8],
        alt:"VENUS G-306 AF CHC/GHC protective eyewear",
        hscode:'',
    },
]


export default eyewear;